import script from "./card-evaluation.vue?vue&type=script&setup=true&lang=ts"
export * from "./card-evaluation.vue?vue&type=script&setup=true&lang=ts"

import "./card-evaluation.vue?vue&type=style&index=0&id=623512a7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-623512a7"]])

export default __exports__